/* eslint-disable */

// ---------------------------------------------
// Modern polyfills using Babel + core-js + regenerator-runtime
// Requires: @babel/preset-env with useBuiltIns: 'entry' and corejs: 3
// ---------------------------------------------

// Core-js provides polyfills for ECMAScript features (Array, Object, Promise, etc.)
import 'core-js/stable';

// Regenerator runtime is required for async/await and generators
import 'regenerator-runtime/runtime';
